import { Export } from '../ExportCompound';

interface GraphicsProps {
  initialModelId?: number;
}

export const Graphics = ({ initialModelId }: GraphicsProps): React.ReactNode => {
  return (
    <div data-testid="graphics-tab">
      <Export>
        <Export.GraphicsMapToggle />
        <Export.Submap initialModelId={initialModelId} />
        <Export.MapFormat />
        <Export.ImageSize />
        <Export.ImageFormat />
        <Export.ImageExportNotice />
        <Export.DownloadGraphics />
        <Export.DownloadMap />
      </Export>
    </div>
  );
};
